import React, { Component } from 'react';
import { Segment, Header, Icon, Grid, Input, Table, Dimmer, Loader, Form, Pagination } from 'semantic-ui-react';

export default class TableSemantic extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		let { click, linesPerPage, totalPages, data } = this.props, userest = false;
		
		data = typeof data === "undefined" ? [] : data;
		
		linesPerPage = linesPerPage ? linesPerPage : 10;
		
		if (data.length == 0)
		{
			userest = true;
			
			totalPages = 1;
		}
		else
		{
			totalPages = Math.ceil(data.length / linesPerPage);
		}
		
		this.state = {
			loading: true,
			setting: {
				header: [
					{ label: "Code", sort: "code" },
					{ label: "Plate", sort: "plate" },
					{ label: "Make", sort: "make" },
					{ label: "Model", sort: "model" },
					{ label: "Type", sort: "type" },
					{ label: "KM", sort: "km" },
					{ label: "Date", sort: "date" },
					{ label: "Price", sort: "price" }
				],
				line: ["code", "plate", "make", "type", "typeInfo", "km", "purchaseDate", "price"],
				align: {
					km: "right",
					price: "right"
				},
				userest: userest,
				activePage: 1,
				totalPages: totalPages,
				linesPerPage: linesPerPage,
				sortField: "",
				sortDesc: false,
				paging: true,
			},
			click: click,
			data: data,
		};
		
		this.pageChange = this.pageChange.bind(this);
		this.load = this.load.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.handleShorting = this.handleShorting.bind(this);
		this.callbackRequest = this.callbackRequest.bind(this);
		this.requestData = this.requestData.bind(this);
	}
	
	componentDidMount() {
		
		if (!document.getElementById("loading-screen"))
		{
			setTimeout(this.load, 1000);
		}
		else
		{
			this.load();
		}
	}
	
	load() {
		
		this.state.setting.userest && this.pageChange(1);
	}
	
	requestData(linesPerPage, search, activePage = false, sortField = "", sortDesc = false) {
		
		const { callbackRequest } = this;
		
		//sortDesc = sortDesc === true ? "true" : "";
		
		const request = {
			linesPerPage: linesPerPage,
			page: activePage,
			search: search,
			sortField: sortField,
			sortDesc: sortDesc
		};
		
		if (!document.getElementById("loading-screen"))
		{
			Service.Post(
				"action_get_history",
				"&linesPerPage="+linesPerPage+"&search="+search+"&page="+activePage+"&sort="+
					sortField+"&desc="+sortDesc,
				callbackRequest
			);
		}
		else
		{
			const GetHistoryRequest = new ActionRequest('action_get_history', request);
			
			GetHistoryRequest.Success = callbackRequest;
			
			GetHistoryRequest.Fail = function(response)
			{
				window.alert(text.errorOnLoad);
			};
			
			GetHistoryRequest.Trigger();
		}
	}
	
	callbackRequest(response) {
		
		//console.log(response);
		
		if (response.success) response = response.data;
		
		let { totalPages, setting, data } = this.state;
		
		if (typeof response !== "undefined")
		{
			if (response.totalPages)
			{
				setting.totalPages = response.totalPages;
			}
			
			if (response.data)
			{
				data = response.data;
			}
			
			if (response.sortField)
			{
				setting.sortField = response.sortField;
			}
			
			if (response.sortDesc)
			{
				setting.sortDesc = response.sortDesc;
			}
		}
		
		this.setState({ loading: false, setting, data });
	}
	
	pageChange(e) {
		
		const activePage = Number.isInteger(e) ? e : parseInt(GetAttributeFromEvent(e, "value"));
		
		const { setting } = this.state;
		
		const { requestData } = this;
		
		const search = document.getElementById("input-history-search").value;
		
		if (setting.userest)
		{
			requestData(setting.linesPerPage, search, activePage, setting.sortField, setting.sortDesc);
			
			setting.activePage = activePage;
			
			this.setState({ loading: true, setting });
		}
		else
		{
			setting.activePage = activePage;
			
			this.setState({ setting });
		}
	}
	
	handleSearch(e) {
		
		let { setting } = this.state;
		
		const { requestData } = this;
		
		const search = e.target[0].value;
		
		requestData(setting.linesPerPage, search, setting.activePage, setting.sortField, setting.sortDesc);
	}
	
	handleShorting(e) {
		
		let { setting } = this.state;
		
		const { requestData } = this;
		
		const search = document.getElementById("input-history-search").value;
		
		const sort = GetAttributeFromEvent(e, "sort");
		
		if (sort == setting.sortField)
		{
			setting.sortDesc = !setting.sortDesc;
		}
		else
		{
			setting.sortField = sort;
		}
		
		requestData(setting.linesPerPage, search, setting.activePage, sort, setting.sortDesc);
		
		this.setState({ loading: true });
	}
	
	render() {
		
		let { loading, setting, click, data } = this.state;
		
		/*data = [
			{ id: 1, class: "bmw", code: 73487, plate: "", make: "BMW", type: "M2 24v", typeInfo: "Steptronic", km: 40000, purchaseDate: "01/2016", price: 60481 },
			{ id: 2, class: "audi", code: 73488, plate: "", make: "Audi", type: "A3", typeInfo: "Trend", km: 50000, purchaseDate: "02/2015", price: 15632 },
			{ id: 3, class: "volkswagen", code: 73489, plate: "", make: "Volkswagen", type: "Golf", typeInfo: "GTi", km: 30000, purchaseDate: "05/2017", price: 28321 },
		];*/
		
		const { pageChange, handleSearch, handleShorting } = this;
		
		const lines = function(a) {
			
			let ret = [];
			
			if (setting.line.length == 0)
			{
				for (var x in a) ret.push(
					<Table.Cell
						textAlign={setting.align[x] ? setting.align[x] : "left"}
						key={x}
					>
						{a[x]}
					</Table.Cell>
				);
			}
			else
			{
				setting.line.map((x) => ret.push(
					<Table.Cell
						textAlign={setting.align[x] ? setting.align[x] : "left"}
						key={x}
					>
						{a[x]}
					</Table.Cell>
				));
			}
			
			return ret;
		};
		
		const dataPaged = function(d) {
			
			if (!setting.userest)
			{
				// Local data paging
				
				const from = (setting.activePage - 1) * setting.linesPerPage;
				
				const to = from + setting.linesPerPage - 1;
				
				return d.filter((a, i) => i >= from && i <= to);
			}
			else if (d.length > 0)
			{
				// Web data, return all
				
				return d;
			}
			else
			{
				// Loading data, return empty lines
				
				let emptyRow = {}, ret = [];
				
				setting.line.forEach((x) => emptyRow[x] = "-");
				
				for (var i = 0; i < setting.linesPerPage; i++)
				{
					let t = JSON.parse(JSON.stringify(emptyRow));
					
					t.id = i;
					
					ret.push(t);
				}
				
				return ret;
			}
		}
		
		const paging = setting.paging && setting.totalPages > 1;
		
		let dataLength = 1;
		
		for (var x in data[0]) dataLength++;
		
		const colSpan = setting.line.length > 0 ? setting.line.length : dataLength;
		
		let content;
		
		if (data.length == 0)
		{
			content = (
				<Segment placeholder>
					<Header icon>
						<Icon name='history' />
						{text.noHistory}
					</Header>
				</Segment>
			);
		}
		else
		{
			content = dataPaged(data).map((d) => (
				<Table.Row key={d.id} code={d.id} onClick={click}>{lines(d)}</Table.Row>
			));
		}
		
		return (
			<div>
				{ loading &&
					<Dimmer active inverted>
						<Loader size='large'>Loading</Loader>
					</Dimmer>
				}
				<Grid>
					<Grid.Row>
						<Grid.Column width={9} />
						<Grid.Column width={7}>
							<Form onSubmit={handleSearch}>
								<Input
									id="input-history-search"
									fluid
									icon='search'
									action='Search'
									iconPosition='left'
									placeholder='Search...'
								/>
							</Form>
						</Grid.Column>
					</Grid.Row>
				</Grid>
				{data.length > 0 ?
					<Table celled selectable sortable>
						<Table.Header>
							<Table.Row>
								{setting.header.map((h, i) => {
								
									const sort = h.sort ? h.sort : "";
									const sorted = h.sort && setting.sortField == h.sort ?
										(setting.sortDesc === true ? "descending" : "ascending") : null;
								
									return (
										<Table.HeaderCell
											key={i}
											sort={sort}
											sorted={sorted}
											onClick={h.sort ? handleShorting : () => false}
										>
											{h.label}
										</Table.HeaderCell>
									);
								})}
							</Table.Row>
						</Table.Header>
						<Table.Body>{content}</Table.Body>
						{ paging &&
							<Table.Footer>
								<Table.Row>
									<Table.HeaderCell colSpan={colSpan}>
										<Pagination
											floated='right'
											firstItem={false}
											lastItem={false}
											activePage={setting.activePage}
											totalPages={setting.totalPages}
											siblingRange={4}
											boundaryRange={3}
											onPageChange={pageChange}
										/>
									</Table.HeaderCell>
								</Table.Row>
							</Table.Footer>
						}
					</Table>
				: content}
			</div>
		);
	}
}